import { render } from "./RadialBarChartStroked.vue?vue&type=template&id=a64dcb7a"
import script from "./RadialBarChartStroked.vue?vue&type=script&lang=js"
export * from "./RadialBarChartStroked.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__